import { render, staticRenderFns } from "./profile-edit.vue?vue&type=template&id=004d681b&"
import script from "./profile-edit.vue?vue&type=script&lang=js&"
export * from "./profile-edit.vue?vue&type=script&lang=js&"
import style0 from "./profile-edit.vue?vue&type=style&index=0&id=004d681b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports